import { css, styled } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledClaimDetailsStatusHistoryItem = styled('div')`
  display: flex;
  flex-direction: row;
`;

export const StyledProgressTimeline = styled('div')(
  ({ theme }) => css`
    position: relative;
    min-width: ${theme.spacing('1XL')};
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    align-items: flex-start;
    margin-right: ${theme.spacing('SMALL')};
  `
);

export const StyledProgressTimelineVertex = styled('div')(
  ({ theme }) => css`
    width: ${theme.spacing('1XL')};
    height: ${theme.spacing('1XL')};
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: ${theme.spacing('MEDIUM')};
      height: ${theme.spacing('MEDIUM')};
      margin: auto;
      background-color: ${theme.palette.main.product_blue};
      border-radius: 100%;
      z-index: 1;
    }
  `
);

export const StyledProgressTimelineEdge = styled('div')(
  ({ theme, first, last, one }) => css`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 2px;
    height: 100%;
    margin: auto;
    background-color: ${theme.palette.main.product_blue};
    z-index: 1;

    ${first &&
    css`
      height: ${theme.spacing('6XL')};
      top: auto;
    `};

    ${last &&
    css`
      height: ${theme.spacing('MEDIUM')};
      bottom: auto;
    `};

    ${one &&
    css`
      height: 0;
    `};
  `
);

export const StyledClaimDetailsStatusHistoryItemDetails = styled('div')(
  ({ theme, last }) => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-bottom: ${last ? '0' : theme.spacing('1XL')};
  `
);
